import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const obtenerPorUserID = async ({ user_id, token }) => {
    return await connection({ method: 'GET', url: `${ENTITY_URL.PERSONA.GET_BY_USER_ID}/${user_id}`, extraHeaders: { token: token } });
}

export default obtenerPorUserID;